import { type QueryFunctionContext, skipToken } from '@tanstack/react-query';
import { z } from 'zod';

export const getBigPromotionResponseSchema = z.object({
  promotion: z
    .object({
      // 'IN_PROGRESS' | 'SCHEDULED' | 'CLOSED
      status: z.string(),
      // 'SOURCE_TYPE_UNSPECIFIED' | 'INTERNAL_LINK'
      sourceType: z.string(),
      sourceId: z.pipe(
        z.transform((value) => {
          if (typeof value !== 'string') {
            return value;
          }

          return Number.parseInt(value, 10);
        }),
        z
          .number()
          .refine((value) => !Number.isNaN(value))
          .catch(0),
      ),
      landingUrl: z.string(),
      sharingMetadata: z
        .object({
          title: z.string(),
          subtitle: z.string(),
          imageUrl: z.string(),
        })
        .optional(),
    })
    .optional(),
  statusCode: z.number().optional(),
});

export type GetBigPromotionResponse = z.infer<
  typeof getBigPromotionResponseSchema
>;
export type GetBigPromotionApi = (params: {
  signal?: AbortSignal;
}) => Promise<GetBigPromotionResponse>;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createGetBigPromotionQueryOptions = ({
  api,
  skip,
}: {
  api: GetBigPromotionApi;
  skip?: boolean;
}) => {
  return {
    queryKey: ['getBigPromotion'],
    queryFn: skip
      ? skipToken
      : ({ signal }: QueryFunctionContext) => api({ signal }),
  } as const;
};
